import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { ConfirmExitGuard } from './guards/confirm-exit.guard';


export const routes: Routes = [
  { path: 'login',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  /*
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/usr-verify-email/usr-verify-email.page').then( m => m.UsrVerifyEmailPage)
  },
  {
    path: 'incident/:id',
    loadComponent: () => import('./pages/view-incident/view-incident.page').then((m) => m.ViewIncidentPage),
    canActivate: [AuthGuard]
  },  

  */
  {
    path: 'room',
    loadComponent: () => import('./pages/room/room.page').then((m) => m.RoomPage),
    canActivate: [AuthGuard],
    canDeactivate: [ConfirmExitGuard]
  },
  
  {
    path: 'menu-user-settings',
    loadComponent: () => import('./pages/usr-settings/menu-user-settings.page').then( m => m.UserSettingsPage),
    canActivate: [AuthGuard]
  },

  {
    path: 'administration/organizations',
    loadComponent: () => import('./pages/admin/organizations/organizations.page').then( m => m.OrganizationsPage),
    canActivate: [AuthGuard]
  },

  {
    path: 'manager/users',
    loadComponent: () => import('./pages/manager/users/users.page').then( m => m.UsersPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/users/add',
    loadComponent: () => import('./pages/manager/users/user-form.page').then(m => m.UserFormPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/users/edit/:id',
    loadComponent: () => import('./pages/manager/users/user-form.page').then(m => m.UserFormPage),
    canActivate: [AuthGuard]
  },  

  {
    path: 'manager/groups',
    loadComponent: () => import('./pages/manager/groups/groups.page').then( m => m.GroupsPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/groups/add',
    loadComponent: () => import('./pages/manager/groups/group-form.page').then(m => m.GroupFormPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/groups/edit/:id',
    loadComponent: () => import('./pages/manager/groups/group-form.page').then(m => m.GroupFormPage),
    canActivate: [AuthGuard]
  },
  
  {
    path: 'manager/vehicles',
    loadComponent: () => import('./pages/manager/vehicles/vehicles.page').then( m => m.VehiclesPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/vehicles/add',
    loadComponent: () => import('./pages/manager/vehicles/vehicle-form.page').then(m => m.VehicleFormPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/vehicles/edit/:id',
    loadComponent: () => import('./pages/manager/vehicles/vehicle-form.page').then(m => m.VehicleFormPage),
    canActivate: [AuthGuard]
  },

  {
    path: 'manager/pois',
    loadComponent: () => import('./pages/manager/pois/pois.page').then( m => m.POIsPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/pois/add',
    loadComponent: () => import('./pages/manager/pois/poi-form.page').then(m => m.POIFormPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/edit/:id',
    loadComponent: () => import('./pages/manager/pois/poi-form.page').then(m => m.POIFormPage),
    canActivate: [AuthGuard]
  },  

  {
    path: 'manager/layers',
    loadComponent: () => import('./pages/manager/layers/layers.page').then( m => m.LayersPage),
    canActivate: [AuthGuard]
  },

  {
    path: 'manager/devices',
    loadComponent: () => import('./pages/manager/devices/devices.page').then( m => m.DevicesPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/devices/add',
    loadComponent: () => import('./pages/manager/devices/device-form.page').then(m => m.DeviceFormPage),
    canActivate: [AuthGuard]
  },  
  {
    path: 'manager/devices/edit/:id',
    loadComponent: () => import('./pages/manager/devices/device-form.page').then( m => m.DeviceFormPage),
    canActivate: [AuthGuard]
  },  

  {
    path: 'manager/resources',
    loadComponent: () => import('./pages/manager/resources/resources.page').then( m => m.ResourcesPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/resources/add',
    loadComponent: () => import('./pages/manager/resources/resource-form.page').then(m => m.ResourceFormPage),
    canActivate: [AuthGuard]
  },  
  {
    path: 'manager/resources/edit/:id',
    loadComponent: () => import('./pages/manager/resources/resource-form.page').then( m => m.ResourceFormPage),
    canActivate: [AuthGuard]
  },    

  {
    path: 'manager/panels',
    loadComponent: () => import('./pages/manager/panels/panels.page').then( m => m.PanelsPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/panels/add',
    loadComponent: () => import('./pages/manager/panels/panel-form.page').then(m => m.PanelFormPage),
    canActivate: [AuthGuard]
  },  
  {
    path: 'manager/panels/edit/:id',
    loadComponent: () => import('./pages/manager/panels/panel-form.page').then( m => m.PanelFormPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'manager/scheduledservices',
    loadComponent: () => import('./pages/manager/scheduledservices/scheduledservices.component').then( m => m.ScheduledServicesComponent),
    canActivate: [AuthGuard]
  },  
  {
    path: 'manager/assignations',
    loadComponent: () => import('./pages/manager/assignations/assignations.page').then( m => m.AssignationsPage),
    canActivate: [AuthGuard]
  },


  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },  
  
  
];

